import React from "react";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";

const aggregateMaterial = (job, showEstimatedQuantities) => {
  const totals = job.items
    .filter(
      (jobItem) =>
        (showEstimatedQuantities
          ? jobItem.estimatedQuantity
          : jobItem.proposedQuantity) &&
        jobItem.item &&
        jobItem.item.itemType
    )
    .reduce((totals, jobItem) => {
      let group = totals[jobItem.item.itemType.id] || {
        name: jobItem.item.itemType.name,
        quantity: 0,
        label: showEstimatedQuantities
          ? jobItem.item.itemType.estimatedQuantityLabel
          : jobItem.item.itemType.quantityLabel,
      };
      group.quantity += showEstimatedQuantities
        ? jobItem.estimatedQuantity
        : jobItem.proposedQuantity;
      totals[jobItem.item.itemType.id] = group;
      return totals;
    }, {});
  return Object.keys(totals).map((k) => totals[k]);
};

const Materials = ({ event, styles, showEstimatedQuantities }) => {
  const materialItemStyle = {
    borderBottom: "1px solid var(--Neutrals-300, #E0E1E2)",
    padding: "4px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const materials = aggregateMaterial(event.job, showEstimatedQuantities);

  if (materials.length === 0) {
    return null;
  }

  return (
    <FormGroup className={styles.dataValuePair}>
      <ControlLabel className={styles.dataValuePairLabel}>
        Materials
      </ControlLabel>
      <FormControl.Static
        className={styles.dataValuePairValue}
        componentClass={"div"}
      >
        <div>
          {materials.map(({ name, quantity, label }, i) => (
            <div key={i} style={materialItemStyle}>
              <span>{name}:</span>
              <span>
                {Math.round(quantity * 1000) / 1000}
                {label ? ` ${label}` : ""}
              </span>
            </div>
          ))}
        </div>
      </FormControl.Static>
    </FormGroup>
  );
};

export default Materials;
